module.exports = __webpack_public_path__ + "img/icon-alert-red.35c9917e.svg";